import { createRouter, createWebHashHistory } from "vue-router";
import Home from "./components/Home.vue";
import Login from "./components/Login.vue";
import Register from "./components/Register.vue";

// lazy-loaded components
const Profile = () => import("./components/Profile.vue");
const BoardAdmin = () => import("./components/BoardAdmin.vue");
const AdminAds = () => import("./components/AdminAds.vue");
const ConfigAdmin = () => import("./components/ConfigAdmin.vue");
const NewsAdmin = () => import("./components/NewsAdmin.vue");
const BoardAds = () => import("./components/Ads.vue");
const BoardModerator = () => import("./components/BoardModerator.vue");
const BoardUser = () => import("./components/BoardUser.vue");
const EmailVerification = () => import("./components/EmailVerification.vue");
const EditUserSettings = () => import("./components/EditUserSettings.vue");
const AdGallery = () => import("./components/AdGallery.vue");
const Vehicle360View = () => import("./components/Vehicle360View.vue");
const ActiveSessions = () => import("./components/ActiveSessions.vue");
const Errors = () => import("./components/Errors.vue");
const RenewalLogs = () => import("./components/RenewalLogs.vue");
const AdminStatistics = () => import("./components/AdminStatistics.vue");
const PartnerStockReport = () => import("./components/PartnerStockReport.vue");
const AvtonetAlerts = () => import("./components/AvtonetAlerts.vue");
const DuplicateListings = () => import("./components/DuplicateListings.vue");
const VehicleRenewalParams = () => import("./components/VehicleRenewalParams.vue");
const RenewalFormHistory = () => import("./components/RenewalFormHistory.vue");
const ActiveStockSearchLogs = () => import("./components/ActiveStockSearchLogs.vue");
const UserMessages = () => import("./components/UserMessages.vue");
const CarshowroomDraftGalleries = () => import("./components/CarshowroomDraftGalleries.vue");
const DoberAvtoSandbox = () => import("./components/DoberAvtoSandbox.vue");
const DoberAvtoAdminLog = () => import("./components/DoberAvtoAdminLog.vue");
const ForgotPassword = () => import("./components/ForgotPassword.vue");
const ResetPassword = () => import("./components/ResetPassword.vue");
const Slideshow = () => import("./components/Slideshow.vue");


// layout imports
import DefaultLayout from './layouts/DefaultLayout.vue';
import EmptyLayout from './layouts/EmptyLayout.vue';
import AuthLayout from './layouts/AuthLayout.vue';

const routes = [
  {
    path: "/slideshow/:userId",
    name: "slideshow",
    component: Slideshow,
    props: true,
    meta: { layout: EmptyLayout, title: 'Showroom', public: true },
  },
  {
    path: "/avto360/:userId/:vehicleId/:imageName",
    name: "vehicle360View",
    component: Vehicle360View,
    props: true,
    meta: { layout: EmptyLayout, title: 'Vehicle 360 View' },
  },
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { layout: AuthLayout, title: 'DOMOV' },
  },
  {
    path: "/edit-user-settings/:userId",
    name: "editUserSettings",
    component: EditUserSettings,
    meta: { layout: DefaultLayout, title: 'NASTAVITVE UPORABNIKA', requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_PARTNER'] },
  },
  {
    path: "/user-messages/:userId",
    name: "userMessages",
    component: UserMessages,
    meta: { layout: DefaultLayout, title: 'SPOROČILA UPORABNIKU', requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_PARTNER'] },
    props: true,
  },
  {
    path: "/home",
    component: Home,
    meta: { layout: AuthLayout, title: 'DOMOV' },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { layout: AuthLayout, title: 'PRIJAVA' },
  },
  {
    path: "/register",
    component: Register,
    meta: { layout: AuthLayout, title: 'REGISTRACIJA' },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    meta: { layout: AuthLayout, title: 'POZABLJENO GESLO' },
  },
  {
    path: "/reset-password/:token",
    name: "reset-password",
    component: ResetPassword,
    meta: { layout: AuthLayout, title: 'PONASTAVITEV GESLA' },
    props: true
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: { layout: DefaultLayout, title: 'PROFIL', requiresAuth: true },
  },
  {
    path: "/ads",
    name: "ads",
    component: BoardAds,
    meta: { layout: DefaultLayout, title: 'OGLASI', requiresAuth: true, roles: ['ROLE_USER'] },
  },
  {
    path: "/carshowroom-drafts",
    name: "carshowroomDrafts",
    component: CarshowroomDraftGalleries,
    meta: { layout: DefaultLayout, title: 'GEMINYCAR DRAFTI', requiresAuth: true, roles: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PARTNER'] },
  },
  {
    path: "/ads/:id",
    name: "adGallery",
    component: AdGallery,
    meta: { layout: DefaultLayout, title: 'UREJANJE OGLASA', requiresAuth: true },
    props: true,
  },

  {
    path: "/admin",
    name: "admin",
    component: BoardAdmin,
    meta: { layout: DefaultLayout, title: 'Klienti', requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_PARTNER'] },
  },
  {
    path: "/admin/oglasi",
    name: "adminAds",
    component: AdminAds,
    meta: { layout: DefaultLayout, title: 'OGLASI', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: "/konfiguracija",
    name: "konfiguracija",
    component: ConfigAdmin,
    meta: { layout: DefaultLayout, title: 'GLOBALNE NASTAVITVE', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: "/novosti",
    name: "novosti",
    component: NewsAdmin,
    meta: { layout: DefaultLayout, title: 'NOVOSTI', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: "/mod",
    name: "moderator",
    component: BoardModerator,
    meta: { layout: DefaultLayout, title: 'Moderator Board', requiresAuth: true, roles: ['ROLE_MODERATOR'] },
  },
  {
    path: "/user",
    name: "user",
    component: BoardUser,
    meta: { layout: DefaultLayout, title: 'User Board', requiresAuth: true, roles: ['ROLE_USER'] },
  },
  {
    path: '/verify-email',
    name: 'EmailVerification',
    component: EmailVerification,
    meta: { layout: AuthLayout, title: 'Email Verification' },
  },
  {
    path: '/reports/active-sessions',
    name: 'activeSessions',
    component: ActiveSessions,
    meta: { layout: DefaultLayout, title: 'AKTIVNE SEJE', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/reports/errors',
    name: 'errors',
    component: Errors,
    meta: { layout: DefaultLayout, title: 'NAPAKE', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/reports/renewal-logs',
    name: 'renewalLogs',
    component: RenewalLogs,
    meta: { layout: DefaultLayout, title: 'RENEWAL LOGS', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/reports/statistika',
    name: 'adminStatistics',
    component: AdminStatistics,
    meta: { layout: DefaultLayout, title: 'STATISTIKA', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/reports/zaloga-partnerjev',
    name: 'partnerStockReport',
    component: PartnerStockReport,
    meta: { layout: DefaultLayout, title: 'ZALOGA PO PARTNERJIH', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/reports/avtonet-obvestila',
    name: 'avtonetAlerts',
    component: AvtonetAlerts,
    meta: { layout: DefaultLayout, title: 'AVTO.NET OBVESTILA', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/reports/duplicate-listings',
    name: 'duplicateListings',
    component: DuplicateListings,
    meta: { layout: DefaultLayout, title: 'PODVOJENI OGLASI', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/reports/parametri-vozila',
    name: 'vehicleRenewalParams',
    component: VehicleRenewalParams,
    meta: { layout: DefaultLayout, title: 'PARAMETRI VOZILA', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/reports/zgodovina-obnov',
    name: 'renewalFormHistory',
    component: RenewalFormHistory,
    meta: { layout: DefaultLayout, title: 'ZGODOVINA OBNOV', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/reports/pametno-iskanje',
    name: 'activeStockSearchLogs',
    component: ActiveStockSearchLogs,
    meta: { layout: DefaultLayout, title: 'PAMETNO ISKANJE', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/admin/doberavto-sandbox',
    name: 'doberAvtoSandbox',
    component: DoberAvtoSandbox,
    meta: { layout: DefaultLayout, title: 'DOBERAVTO SANDBOX', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
  {
    path: '/admin/doberavto-log',
    name: 'doberAvtoAdminLog',
    component: DoberAvtoAdminLog,
    meta: { layout: DefaultLayout, title: 'DOBERAVTO LOG', requiresAuth: true, roles: ['ROLE_ADMIN'] },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// Funkcija za dekodiranje JWT žetona
function decodeJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Failed to decode token:', e);
    return null;
  }
}

// Preverjanje veljavnosti žetona (seje)
function isTokenExpired() {
  const user = JSON.parse(localStorage.getItem('user'));
  if (!user || !user.accessToken) {
    return true;
  }

  const decodedToken = decodeJwt(user.accessToken);
  if (!decodedToken) {
    return true; // Če dekodiranje ne uspe, obravnavamo žeton kot neveljaven
  }

  return decodedToken.exp * 1000 < Date.now(); // Preverimo, če je žeton potekel
}

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/home', '/', '/verify-email', '/forgot-password'];
  // More robust check for public pages
  const isPublic = publicPages.includes(to.path) ||
      to.path.startsWith('/reset-password') ||
      to.matched.some(record => record.meta.public);

  const authRequired = !isPublic;
  const loggedIn = localStorage.getItem('user');

  // Check if token is expired
  const tokenExpired = loggedIn ? isTokenExpired() : true;

  // 1. If user is logged in
  if (loggedIn && !tokenExpired) {
    const user = JSON.parse(loggedIn);
    const roles = user.roles || [];

    // 1a. If trying to access a public page (that isn't for email verification), redirect to their dashboard
    if (publicPages.includes(to.path) && to.path !== '/verify-email') {
      if (roles.includes('ROLE_ADMIN')) {
        return next('/admin');
      }
      if (roles.includes('ROLE_PARTNER')) {
        return next('/admin');
      }
      if (roles.includes('ROLE_USER')) {
        return next('/ads');
      }
      return next('/profile'); // Fallback for other roles
    }

    // 1b. Role-based access for protected pages
    if (to.meta.roles && !to.meta.roles.some(role => roles.includes(role))) {
      // User does not have permission, redirect to their default dashboard
      if (roles.includes('ROLE_ADMIN')) {
        return next('/admin');
      }
      if (roles.includes('ROLE_PARTNER')) {
        return next('/admin');
      }
      if (roles.includes('ROLE_USER')) {
        return next('/ads');
      }
      return next('/profile'); // Fallback
    }

    // 1c. User is logged in and has access
    return next();
  }

  // 2. If user is NOT logged in
  // 2a. If trying to access a protected page, redirect to login
  if (authRequired) {
    return next('/login');
  }

  // 2b. User is not logged in and is accessing a public page
  return next();
});

export default router;
